import { useEffect, useRef, useState } from 'react';
import Course from './course';
import SelectedCourses from '../sections/selectedCourses';
import { PropTypes } from 'prop-types';
// import axios from 'axios';
// import { apis } from '../api/apiUrl';
// import { showImage } from '../api/functions';
import { CourseCardSkelton } from './skeltons';
import {  useSelector } from 'react-redux';
import { retrunAssets } from '../utils/getAssets';
// import { useInView } from 'framer-motion';



const Courses = ({ useIsInView }) => {
    const [showCourses, setShowCourses] = useState(true);
   const [data, setData] = useState([])
    // const [selectedCourses,] = useState([
    //     "Foundation In Engineering",
    //     "Diploma in Electrical Engineering",
    //     "Bachelor of Electrical Power Engineering",
    //     "Doctor of Philosophy (Engineering)",
    //     "Master of Electrical Engineering",
    // ]);



    const handleGoBack = () => {
        setShowCourses(true);
    };
    const ref = useRef(null)
    // const isInViewRef = useInView(ref, { once: true });
    const [loading,] = useState(false)

    // useEffect(() => {
    //     async function fetchData() {
    //         const response = await axios.get(apis.baseUrl + apis.getCourses);
    //         setData(response?.data.courses?.map(d => {
    //             return {
    //                 img: `${showImage(d.categoryImage)}`,
    //                 name: d.courseName
    //             }
    //         }));
    //         setLoading(false)
    //     }
    //    if(isInViewRef){
    //           fetchData();
    //    }
    // }, [isInViewRef]);




    const state = useSelector(state => state.homepage)
    



    // const courses = [
    //     {
    //         name: 'Computing',
    //         img: "/assets/computer.jpg"
    //     },
    //     {
    //         name: 'Engineering',
    //         img: "/assets/engineer.jpg"
    //     },
    //     {
    //         name: 'Business',
    //         img: "/assets/business.jpg"
    //     },
    // ];

    useEffect(()=>{
        if (state?.data?.properties?.colleges?.items) {
            const courses = state?.data?.properties?.colleges?.items.map(d => {
                return {
                    name: d?.content?.properties?.collegeName,
                    img: retrunAssets(d?.content?.properties?.image[0].url),
                    courses: d?.content?.properties?.courses?.items
                }
            })
            setData(courses)
        }
           
    },[state?.data?.properties?.colleges?.items])
   
   
    const [selectedCourses, setSelectedCourses] = useState([])

    const handleCourseClick = (course) => {
        setShowCourses(false);
        setSelectedCourses(course.courses?.map(d =>
        (
            {
                title: d?.content?.properties?.title,
                path: d?.content?.properties?.coursePath[0]?.route?.path
            }
        )
        ))
    };

    const cardAnimation = [
        { inView: "lg:!translate-y-0 lg:opacity-100", outView: "lg:!translate-y-full lg:opacity-10" },
        { inView: "lg:!translate-x-0 lg:!translate-y-0 lg:opacity-100", outView: "lg:!translate-y-full lg:!-translate-x-full lg:opacity-10" },
        { inView: "lg:!translate-y-0 lg:opacity-100", outView: "lg:!translate-y-full lg:opacity-10" },
    ]




    return (
        <div ref={ref} className='w-full min-h-96 2xl:w-11/12 py-4  mt-6'

        >
            {showCourses ? (

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8  place-items-center">
                    {

                        loading ?
                            [0, 1, 2].map(item =>
                                <div

                                    style={{
                                        transition: "all 0.8s cubic-bezier(0.17, 0.55, 0.55, 1) 0.8s"
                                    }}
                                    className={`w-full ${useIsInView ? cardAnimation[item].inView : cardAnimation[item].outView} }`}
                                    key={item}>
                                    <CourseCardSkelton />
                                </div>
                            )

                            :
                            data?.slice(0, 3).map((course, index) => (
                                <div

                                    style={{
                                        transition: "all 0.8s cubic-bezier(0.17, 0.55, 0.55, 1) 0.8s"
                                    }}
                                    className={`w-full ${useIsInView ? cardAnimation[index].inView : cardAnimation[index].outView} }`}
                                    key={index} onClick={() => handleCourseClick(course)}>
                                    <Course {...course} />
                                </div>
                            ))}

                </div>
            ) : (
                <SelectedCourses
                    showSelectedCourse={!showCourses}
                    selectedCourses={selectedCourses}
                    clickGoBack={handleGoBack}
                />
            )
            }
        </div >
    );
}
Courses.propTypes = {
    useIsInView: PropTypes.bool
}
export default Courses;
